import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/gauge-horizontal/gauge-horizontal.js';
      import {ExternalScaleSide, FillMode} from '@oicl/openbridge-webcomponents/dist/building-blocks/external-scale/external-scale.js';
import {BorderRadiusPosition, Priority, InstrumentState} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {AdviceType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';

      export interface Props {
     minValue?: number;
     maxValue?: number;
     side?: ExternalScaleSide;
     showLabels?: boolean;
     mainTickmarks?: number[] | undefined;
     primaryTickmarkInterval?: number | undefined;
     secondaryTickmarkInterval?: number | undefined;
     tertiaryTickmarkInterval?: number | undefined;
     borderRadiusPosition?: BorderRadiusPosition | undefined;
     priority?: Priority;
     fillMode?: FillMode;
     fillMin?: number | undefined;
     fillMax?: number | undefined;
     value?: number | undefined;
     state?: InstrumentState;
     focused?: boolean;
     advices?: { min: number; max: number; type: AdviceType; hinted: boolean; }[] | undefined;
     highlightCurrentValue?: boolean;
     setpoint?: number | undefined;
     newSetpoint?: number | undefined;
     atSetpoint?: boolean;
     touching?: boolean;
     autoAtSetpoint?: boolean;
     autoAtSetpointDeadband?: number;
     setpointAtZeroDeadband?: number;
     setpointOverride?: boolean;
     animateSetpoint?: boolean
   }

      
  
      export type {ExternalScaleSide, FillMode} from '@oicl/openbridge-webcomponents/dist/building-blocks/external-scale/external-scale.js';
export type {BorderRadiusPosition, Priority, InstrumentState} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {AdviceType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcGaugeHorizontal',
  props: {
    minValue: {},
    maxValue: {},
    side: {},
    showLabels: { type: Boolean },
    mainTickmarks: {},
    primaryTickmarkInterval: {},
    secondaryTickmarkInterval: {},
    tertiaryTickmarkInterval: {},
    borderRadiusPosition: {},
    priority: {},
    fillMode: {},
    fillMin: {},
    fillMax: {},
    value: {},
    state: {},
    focused: { type: Boolean },
    advices: {},
    highlightCurrentValue: { type: Boolean },
    setpoint: {},
    newSetpoint: {},
    atSetpoint: { type: Boolean },
    touching: { type: Boolean },
    autoAtSetpoint: { type: Boolean },
    autoAtSetpointDeadband: {},
    setpointAtZeroDeadband: {},
    setpointOverride: { type: Boolean },
    animateSetpoint: { type: Boolean }
  },
  emits: ["scale-dimensions-changed"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onScaleDimensionsChanged: (event: CustomEvent) => emit('scale-dimensions-changed', event as CustomEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-gauge-horizontal',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})